export const API_URL = process.env.REACT_APP_API_URL || 'https://book-review-backend-pl3j.onrender.com';

export const THUMBSNAP_CONFIG = {
  API_KEY: process.env.REACT_APP_THUMBSNAP_API_KEY,
  API_URL: 'https://thumbsnap.com/api',
};
